/**
 * logger — THE frontend logging primitive (E-14, 2026-07-07).
 *
 * The codebase had 1,300+ raw console.log calls spamming user consoles in production.
 * All of them now route through logger.debug, which is SILENT in production builds
 * unless explicitly re-enabled at runtime via `localStorage.mabatDebug = '1'` (then
 * reload) — so field debugging stays possible without a rebuild.
 *
 * warn/error always print (they are signals, not noise). Keep NEW debug chatter on
 * logger.debug; reserve logger.info for the few genuinely-operational messages.
 */

// Cached once (refreshed on the storage event) so hot paths never pay a
// localStorage read per logger.debug call.
let cachedDebug: boolean | null = null;
const computeDebugEnabled = (): boolean => {
  if (process.env.NODE_ENV !== 'production') return true;
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('mabatDebug') === '1';
  } catch {
    return false;
  }
};
if (typeof window !== 'undefined') {
  window.addEventListener('storage', () => { cachedDebug = null; });
}
const debugEnabled = (): boolean => {
  if (cachedDebug === null) cachedDebug = computeDebugEnabled();
  return cachedDebug;
};

export const logger = {
  debug: (...args: any[]): void => {
    if (debugEnabled()) console.log(...args);
  },
  info: (...args: any[]): void => {
    console.log(...args);
  },
  warn: (...args: any[]): void => {
    console.warn(...args);
  },
  error: (...args: any[]): void => {
    console.error(...args);
  },
};
